import lazySizes from "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";
import "grid/grid";
import "a11y";
import "player";
import "slider";

// set correct lazy img format
// lazySizes.cfg.loadMode = 0;
document.addEventListener("lazybeforeunveil", (e) => {
    let imgEl = e.target;

    if (!imgEl.classList.contains("lazyload__artist")) {
        return;
    }

    let imgWidth = parseFloat(
            getComputedStyle(imgEl.parentNode, null).width.replace("px", "")
        ),
        imgHeight = parseFloat(
            getComputedStyle(imgEl.parentNode, null).height.replace("px", "")
        ),
        imgFormat = imgWidth > imgHeight ? "landscape" : "portrait", //imgEl.getAttribute("data-format"),
        imgSrc = imgEl.getAttribute("data-src-" + imgFormat);

    imgEl.src = imgSrc;
});

// scrollto
let scrollToEls = document.querySelectorAll("[data-scrollto]");
if (scrollToEls) {
    scrollToEls.forEach((el) => {
        el.addEventListener("click", () => {
            let anchorName = el.getAttribute("data-scrollto"),
                anchorEl = document.querySelector(anchorName);
            console.log(anchorName, anchorEl);
            if (anchorEl) {
                anchorEl.scrollIntoView({
                    behavior: "smooth",
                });
            }
        });
    });
}

// imagehover
let images = document.querySelectorAll(".imagehover"),
    activeClassname = "is-active";
if (images) {
    images.forEach((el) => {
        el.addEventListener("mouseenter", (e) => {
            images.forEach((el) => {
                el.classList.remove(activeClassname);
            });
            el.classList.add(activeClassname);
        });
    });
}
